module.exports = __webpack_public_path__ + "static/media/selected-bar-graph.62ca478a.svg";